import React from 'react';
import styled from 'styled-components';
import { Layout } from 'antd';

import Logo from '../Components/Logo';

const { Content, Footer } = Layout;

const StyledFooter = styled(Footer)`
  z-index: 1;
  background: #192842;
  padding: 5px;
`;

const ContentWrapper = styled(Content)`
  overflow-y: scroll;
  height: calc(100vh - 75px);
`;

const OpenPageBase: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Layout>
    <ContentWrapper>{children}</ContentWrapper>
    <StyledFooter style={{ textAlign: 'center' }}>
      <Logo />
    </StyledFooter>
  </Layout>
);

export default OpenPageBase;
